define('plugin/invoice/view/InvoicePaymentSystemView',['require','lib/view/CompositeView','plugin/invoice/view/InvoicePaymentSystemItemView'],function (require) {

    var CompositeView = require('lib/view/CompositeView');
    var InvoicePaymentSystemItemView = require('plugin/invoice/view/InvoicePaymentSystemItemView');

    /**
     * Invoice payment system view
     *
     * @class InvoicePaymentSystemView
     */
    return CompositeView.extend({

        template: '#invoice_payment_system_view',
        childView: InvoicePaymentSystemItemView,
        childViewContainer: '#sb_invoice_payment_systems_container',

        collectionEvents: {
            'sync': '_onSync'
        },

        initialize: function() {
            CompositeView.prototype.initialize.apply(this);
        },

        _onSync: function() {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        _delayAllowed: function () {
            const isDelayAllowed = !(!this.model.get('payment_received') && this.model.get('status') === 'paid');

            const isDeposit = this.model.get('is_with_deposit_amount');
            if(!isDeposit) {
                return isDelayAllowed;
            }else{
                return isDelayAllowed && this._delayAllowedForDeposit();
            }
        },

        _delayAllowedForDeposit: function () {
            //allowed if configured in deposit custom feature or if pay full amount
            return this.model.get('deposit_is_client_can_pay_later') || this.model.get('rest_amount') === 0;
        },

        filter: function (itemModel) {
            return !(itemModel.get('id') === 'delay' && !this._delayAllowed());
        },

        serializeData: function () {
            var data = CompositeView.prototype.serializeData.apply(this);

            data.cnt = this.collection.length;
            data.hide_payment_processors = false;
            if (this.collection.length === 1 || (this.collection.length === 2 && !this._delayAllowed())) {
                var first = this.collection.first();
                if (first.get('is_delay')) {
                    data.hide_payment_processors = true;
                }
            }

            if (this.collection.length === 0 ) {
                data.hide_payment_processors = true;
            }

            return data;
        }

    });

});
